var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro"},[_c('h1',{staticClass:"font-serif"},[_vm._v(_vm._s(_vm.intros[_vm.$route.name].title))]),_c('p',{staticClass:"font-sans",domProps:{"innerHTML":_vm._s(_vm.intros[_vm.$route.name].description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }